import gettext from '@sdk/lang/gettext';

import { useNavigate } from '@web/Router/router.hooks';
import { useConversationCreateRestrictions } from '@web/conversations/ComposeConversation/composeConversation.hooks';

import {
  Member,
  MemberButton,
  MemberLink,
  MemberMenu,
  MemberMenuItem,
} from './conversationMembers.styles';
import { Member as MemberType } from './conversationMembers.types';

type Props = {
  items: MemberType[];
};

export const MembersList = ({ items }: Props) => {
  const navigate = useNavigate();
  const { canStartPrivateConversation } = useConversationCreateRestrictions();

  return (
    <>
      {items.map((member) =>
        member.isMe ? (
          <MemberLink
            key={member.id}
            onClick={() => navigate.toUserProfile({ params: { id: member.id } })}>
            {member.displayName}
          </MemberLink>
        ) : (
          <Member key={member.id}>
            <MemberButton tabIndex={-1}>{member.displayName}</MemberButton>
            <MemberMenu>
              <MemberMenuItem
                onMouseDown={() => navigate.toUserProfile({ params: { id: member.id } })}>
                {gettext('View profile')}
              </MemberMenuItem>
              {canStartPrivateConversation && (
                <MemberMenuItem
                  onMouseDown={() =>
                    navigate.toConversationStart({
                      queryParams: {
                        userId: member.id,
                      },
                    })
                  }>
                  {gettext('Direct message')}
                </MemberMenuItem>
              )}
            </MemberMenu>
          </Member>
        )
      )}
    </>
  );
};
